import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewPromoterPayoutPageNew from "../../components/PromoterPayout/ViewPromoterPayoutPageNew";

const ViewPromoterPayoutPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb
        id="title"
        title2="Promoter Payout Management"
        link2="/promoter-payout"
        title="View Promoter Payout"
      />
      <ViewPromoterPayoutPageNew />
    </MasterLayout>
  );
};

export default ViewPromoterPayoutPage;
